(() => {
  const root = document.querySelector("[data-founding-cats]");
  if (!root) return;

  const form = root.querySelector("#FoundingCatsForm");
  const submit = root.querySelector("[data-founding-cats-submit]");
  const catNameInput = root.querySelector("[data-cat-name-input]");
  const passName = root.querySelector("[data-pass-name]");

  if (catNameInput && passName) {
    const syncCatName = () => {
      const value = catNameInput.value.trim();
      passName.textContent = value ? `${value.toUpperCase()} + YOU` : "YOUR CAT + YOU";
    };

    catNameInput.addEventListener("input", syncCatName);
    syncCatName();
  }

  if (form && submit) {
    form.addEventListener("submit", () => {
      if (!form.checkValidity()) return;

      submit.disabled = true;
      submit.setAttribute("aria-busy", "true");
      submit.querySelector("[data-submit-label]").textContent = "SENDING TO SARAH…";
    });
  }
})();
